import {memo} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {MessageCircle} from 'lucide-react';
import {Button, NumberedList, ResponsiveSheet} from '@chekinapp/ui';
import {EXPLAINER_LIST} from './styles';

type Props = {
  isOpen: boolean;
  close: () => void;
  onMessageProperty?: () => void;
};

const PetFeeInfoModal = memo(({isOpen, close, onMessageProperty}: Props) => {
  const {t} = useTranslation();

  return (
    <ResponsiveSheet
      open={isOpen}
      onClose={close}
      title={t('pet_fee_info_title')}
      description={t('pet_fee_info_description')}
      className="pet-fee-info-modal"
      dialogClassName="max-w-[400px] sm:max-w-[400px]"
      closeOnOverlayClick
      contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
    >
      <div className="mt-4 flex flex-col gap-5">
        <NumberedList size="sm" className={EXPLAINER_LIST}>
          <Trans i18nKey="pet_fee_is_not_an_extra_you_chose" />
          <Trans i18nKey="pet_fee_ask_the_property_to_update" />
        </NumberedList>
        <div className="flex flex-col gap-2.5">
          {onMessageProperty && (
            <Button variant="outline" onClick={onMessageProperty}>
              <MessageCircle />
              {t('message_the_property')}
            </Button>
          )}
          <Button onClick={close}>{t('got_it')}</Button>
        </div>
      </div>
    </ResponsiveSheet>
  );
});

export {PetFeeInfoModal};
